/* Theme-scoped cart; Shopify remains the source of truth for prices and item properties. */
(() => {
  if (window.phCartInitialized) return;
  window.phCartInitialized = true;
  const root = window.Shopify?.routes?.root || '/';
  let busy = false, unverified = false, checkoutVisible = false, intersection, pendingRemoval;
  const cart = () => document.querySelector('[data-ph-cart]');
  const status = message => { const el = cart()?.querySelector('[data-ph-status]'); if (el) el.textContent = message; };
  const sticky = () => {
    const bar = cart()?.querySelector('[data-ph-sticky]');
    if (!bar) return;
    const frame = document.getElementById('PBarNextFrameWrapper');
    const frameRect = frame?.getBoundingClientRect();
    bar.style.setProperty('--ph-cart-bottom', frameRect && frameRect.bottom > 0 && frameRect.top < innerHeight ? Math.max(0,innerHeight-frameRect.top)+12+'px' : '12px');
    const overlay = document.querySelector('.t4s-close-overlay');
    const menuOpen = overlay && getComputedStyle(overlay).visibility !== 'hidden' && Number(getComputedStyle(overlay).opacity) > 0;
    bar.hidden = checkoutVisible || menuOpen || !!document.querySelector('dialog[open]') || document.documentElement.classList.contains('ph-editor-open');
  };
  const bind = () => {
    intersection?.disconnect();
    const button = cart()?.querySelector('.ph-checkout');
    checkoutVisible = false;
    if (button) {
      intersection = new IntersectionObserver(entries => { checkoutVisible = entries[0].isIntersecting; sticky(); });
      intersection.observe(button);
    }
    sticky();
  };
  const setBusy = value => {
    busy = value;
    const element = cart();
    if (!element) return;
    element.setAttribute('aria-busy', String(value));
    element.querySelectorAll('[data-ph-checkout],[data-ph-input],[data-ph-quantity]').forEach(el => el.disabled = value);
    if(unverified)element.querySelectorAll('[data-ph-checkout]').forEach(el=>el.disabled=true);
  };
  const refresh = async () => {
    const element = cart();
    const url = new URL(root + 'cart', location.origin);
    url.searchParams.set('section_id', element.dataset.section);
    const response = await fetch(url, { cache: 'no-store' });
    if (!response.ok) throw Error('Please refresh the page to see your updated cart.');
    const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
    const replacement = doc.querySelector('[data-ph-cart]');
    if (!replacement) throw Error('Please refresh the page to see your updated cart.');
    element.replaceWith(replacement);
    unverified=false;
    document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = replacement.dataset.count);
    bind();
  };
  const change = async (item, quantity, focus) => {
    if (busy) return;
    setBusy(true); status('Updating your cart…');
    try {
      const response = await fetch(root + 'cart/change.js', { method: 'POST', headers: {'Content-Type':'application/json'}, body: JSON.stringify({id:item.dataset.key,quantity}) });
      const data = await response.json();
      if (!response.ok) throw Error(data.description || data.message || 'Your cart could not be updated. Please try again.');
      await refresh(); status('Cart updated.');
      if (focus) document.getElementById(focus)?.focus({preventScroll:true});
    } catch (error) {
      try { await refresh(); } catch { unverified=true; }
      status(error.message || 'Please refresh your cart and try again.');
    } finally { setBusy(false); }
  };
  document.addEventListener('click', event => {
    const element = event.target.closest('[data-ph-cart]');
    if (!element) return;
    if (event.target.closest('[data-ph-cancel-remove]')) { element.querySelector('.ph-remove-dialog')?.close(); pendingRemoval = null; sticky(); return; }
    if (event.target.closest('[data-ph-confirm-remove]')) {
      const item = pendingRemoval; element.querySelector('.ph-remove-dialog')?.close(); pendingRemoval = null;
      if (item?.isConnected) change(item, 0); sticky(); return;
    }
    const preview = event.target.closest('[data-ph-preview]');
    if (preview) {
      const dialog = element.querySelector('.ph-preview');
      const img = dialog.querySelector('[data-ph-preview-image]');
      img.src = preview.dataset.phPreview; img.alt = 'Your personalized ' + preview.dataset.title;
      dialog.showModal(); sticky(); return;
    }
    if (event.target.matches?.('dialog.ph-preview')) {
      const rect=event.target.getBoundingClientRect();
      if(event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom){event.target.close();sticky();return;}
    }
    if (event.target.closest('[data-ph-close]')) { element.querySelector('.ph-preview')?.close(); sticky(); return; }
    const item = event.target.closest('[data-ph-item]');
    if (!item) return;
    const remove = event.target.closest('[data-ph-remove]');
    const quantityButton = event.target.closest('[data-ph-quantity]');
    if (remove || quantityButton) {
      event.preventDefault(); if (busy) return;
      if (remove) {
        pendingRemoval = item;
        const dialog = element.querySelector('.ph-remove-dialog');
        const img = item.querySelector('.ph-item__image img');
        const target = dialog.querySelector('[data-ph-remove-image]');
        target.hidden = !img; if (img) target.src = img.currentSrc || img.src;
        dialog.showModal(); sticky(); return;
      }
      const input = item.querySelector('[data-ph-input]');
      const next = quantityButton ? Number(input.value) + Number(quantityButton.dataset.phQuantity) * Number(input.step || 1) : 0;
      if (quantityButton && next < Number(input.min)) return;
      if (input.max && next > Number(input.max)) { status('This item has a maximum quantity of ' + input.max + '.'); return; }
      change(item,next,input.id);
    }
    if (busy && event.target.closest('a')) event.preventDefault();
  });
  document.addEventListener('change', event => {
    const input = event.target.closest('[data-ph-input]');
    if (!input) return;
    if (!input.checkValidity() || !Number.isInteger(Number(input.value))) { input.reportValidity(); input.value = input.dataset.original; return; }
    change(input.closest('[data-ph-item]'), Number(input.value), input.id);
  });
  document.addEventListener('submit', event => {
    if (event.target.id !== 'PHCartForm') return;
    if (busy || unverified || event.submitter?.name !== 'checkout') event.preventDefault();
  });
  document.addEventListener('close', sticky, true);
  document.addEventListener('shopify:section:load', bind);
  new MutationObserver(sticky).observe(document.documentElement,{subtree:true,attributes:true,attributeFilter:['class','open']});
  bind();
})();
